import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import AddApps from 'features/apps/add-apps/components';
import { Spinner } from 'commons/components/spinner';
import { Box, Flex } from '@sparrowengg/twigs-react';
import { devPortalServices } from 'commons/services';

const EditApp = () => {
  const params = useParams();
  const [app, setApp] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const convertToYouTubeURL = (embedUrl: string): string => {
    const embedRegex = /\/embed\/([^/?]+)/;
    const match = embedUrl?.match(embedRegex);
    if (match && match[1]) {
      return `https://www.youtube.com/watch?v=${match[1]}`;
    } else {
      return embedUrl;
    }
  };

  const fetchSingleApp = async (id: string) => {
    setLoading(true);
    try {
      const response = await devPortalServices.getSingleApp(id);
      response.videoUrl = convertToYouTubeURL(response?.videoUrl);
      setApp(response);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSingleApp(`${params.id}`);
  }, [searchParams.get('fileName'), params?.id]);

  return (
    <>
      {loading ? (
        <Flex
          alignItems="center"
          justifyContent="center"
          css={{ width: '100%', height: 'calc(100vh - 64px)' }}
        >
          <Spinner size="md" />
        </Flex>
      ) : (
        <Box css={{ height: 'calc( 100vh - 72px )' }}>
          <AddApps app={app} />
        </Box>
      )}
    </>
  );
};

export default EditApp;
